import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ChevronDown } from "lucide-react";
import { getTutorialVideo } from "../../reducers/analytics.slice";
import PageHeader from "../../components/shared/PageHeader";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "../../components/ui/collapsible";
import useMediaQuery from "../../components/shared/useMediaQuery";

const accordionData = [
  {
    id: "1",
    question: "How do I reset my password?",
    answer: "Go to the login screen and click on 'Forgot Password' to initiate the reset process.",
  },
  {
    id: "2",
    question: "How do I track my order?",
    answer: "You can track your order by visiting our order tracking page and entering your order number.",
  },
  {
    id: "3",
    question: "How do I change my shipping address?",
    answer:
      "To change your shipping address, please log in to your account and update your address information in the 'Shipping Address' section.",
  },
  {
    id: "4",
    question: "How do I contact customer support?",
    answer: "You can reach our customer support team by visiting the 'Contact Us' section on our website.",
  },
];

function FaqItem({ question, answer, open, onToggle }) {
  return (
    <Collapsible open={open} onOpenChange={onToggle}>
      <div style={{ border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, overflow: "hidden" }}>
        <CollapsibleTrigger asChild>
          <button
            type="button"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "14px 18px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#fff",
              fontSize: 13.5,
              fontWeight: 700,
              textAlign: "left",
            }}
          >
            {question}
            <ChevronDown
              size={16}
              style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.15s", color: "#c3c8cc", flexShrink: 0, marginLeft: 12 }}
            />
          </button>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div style={{ padding: "0 18px 16px", fontSize: 13, lineHeight: 1.6, color: "#c3c8cc" }}>{answer}</div>
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
}

export default function MemberHelpAndSupportPage() {
  const dispatch = useDispatch();
  const [videoLink, setVideoLink] = useState("");
  const [openFaqId, setOpenFaqId] = useState(null);
  const isMobile = useMediaQuery("(max-width: 640px)");

  useEffect(() => {
    dispatch(getTutorialVideo({ tut_id: "faq_1" })).then((res) => {
      if (res?.error && Object.keys(res?.error)?.length > 0) {
        setVideoLink(
          "https://rsc-application-artifacts.s3.amazonaws.com/faq_data/demo.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA5FTZENMHAFIJYE7Y%2F20250210%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20250210T102507Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=691845fc954034684daa8f03abc2bd3999f1437207d3ecc492deea864373ef4a"
        );
        return;
      }
      setVideoLink(res?.payload?.url);
    });
  }, []);

  return (
    <div style={{ width: "100%", maxWidth: 640, margin: "0 auto", display: "flex", flexDirection: "column", gap: isMobile ? 18 : 24 }}>
      <PageHeader title="Help & Support" subtitle="Find answers to common questions or reach out to us for further assistance." />

      {videoLink && (
        <video
          src={videoLink}
          autoPlay
          controls
          playsInline
          muted
          style={{
            height: isMobile ? 220 : 380,
            width: "100%",
            maxWidth: "100%",
            borderRadius: 14,
            border: "1px solid rgba(255,255,255,0.08)",
            objectFit: "contain",
          }}
        />
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {accordionData.map((item) => (
          <FaqItem
            key={item.id}
            question={item.question}
            answer={item.answer}
            open={openFaqId === item.id}
            onToggle={(isOpen) => setOpenFaqId(isOpen ? item.id : false)}
          />
        ))}
      </div>

      <p style={{ fontSize: 13, color: "#c3c8cc", textAlign: "center", margin: 0 }}>
        If your issue isn't covered in the FAQs, you can reach out to us through Discord for further assistance.
      </p>
    </div>
  );
}
